module.exports = "<div class=\"renderer-container\">\n  <div [ngClass]=\" statusCSS \">\n    <span class=\"centerAlignText\">{{cellValue | uppercase}}</span>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/custom-cell-renderer/custom-cell-renderer.component.html
// module id = ../../../../../src/app/shared/components/custom-cell-renderer/custom-cell-renderer.component.html
// module chunks = main